import { useTranslation } from 'react-i18next'
import { translateApiError } from '@/lib/apiError'

/**
 * Returns a memoized error-translation function bound to the given i18next
 * namespace plus the common namespace.
 *
 * Usage:
 *   const translateError = useApiErrorTranslator('invoices')
 *   // inside a mutation's onError / catch:
 *   addToast({ type: 'error', message: translateError(err) })
 *
 * The returned function accepts an optional `fallback` string that is used
 * when every other resolution path fails.
 */
export function useApiErrorTranslator(
  namespace: string,
): (err: unknown, opts?: { fallback?: string }) => string {
  const { t } = useTranslation(namespace)
  const { t: tc } = useTranslation('common')

  return (err: unknown, opts?: { fallback?: string }) =>
    translateApiError(err, namespace, { t, tc, fallback: opts?.fallback })
}
